import React from 'react'
import EurestoDiv from 'EurestoComponents/EurestoDiv/index'
import Constants from 'EurestoFonction/Constants'
import {Fab, Grid} from '@material-ui/core'
import User from 'EurestoClass/User'

import Select from 'Components/Select'
import Data from 'EurestoClass/Data'
import ApiRequest from 'EurestoApi/ApiRequest'

import {Draggable, Droppable} from 'react-drag-and-drop'
import Utils from 'EurestoFonction/Utils'

const project = require('EurestoConfig/project.config')

export default class extends React.Component {
  constructor (props) {
    super(props)
    const search = {}
    if (User.TypeAccess.get(Constants.access.EURESTO)) {
      search.actif = { not: true, value: 3 }
    }
    let dataonglet = Data.list(Constants.module.CRM, Constants.donnee.info_tiers, search)

    dataonglet.sort((a, b) => {
      if (a.onglet_id === b.onglet_id) {
        if (a.ordre === b.ordre) {
          return ('' + a.libelle).localeCompare(b.libelle)
        }
        return a.ordre - b.ordre
      }
      return a.onglet_id - b.onglet_id
    })
    let onglet = Data.list(Constants.module.CRM, Constants.donnee.onglet)
    this.state = {
      dataonglet: dataonglet,
      onglet: onglet,
    }
  }

  restateInfoTiers = () => {
    const search = {}
    if (User.TypeAccess.get(Constants.access.EURESTO)) {
      search.actif = { not: true, value: 3 }
    }
    let dataonglet = Data.list(Constants.module.CRM, Constants.donnee.info_tiers, search)

    dataonglet.sort((a, b) => {
      if (a.onglet_id === b.onglet_id) {
        if (a.ordre === b.ordre) {
          return ('' + a.libelle).localeCompare(b.libelle)
        }
        return a.ordre - b.ordre
      }
      return a.onglet_id - b.onglet_id
    })
    this.setState({
      dataonglet: dataonglet
    })
  }

  restateOnglet = () => {
    this.setState({
      onglet: Data.list(Constants.module.CRM, Constants.donnee.onglet)
    })
  }

  componentWillMount () {
    Data.addCbRestate(Constants.module.CRM, Constants.donnee.info_tiers, this.restateInfoTiers)
    Data.addCbRestate(Constants.module.CRM, Constants.donnee.onglet, this.restateOnglet)
  }

  render () {
    return (
      <Grid container spacing={0} direction="row" justify="flex-start" alignItems="flex-start"
            style={{
              margin: 0,
              padding: 0,
              //marginTop: '15px',
            }}>
        <Grid item xs={4} style={{ margin: 0, padding: 10 }}>
          <EurestoDiv title={'Liste des Critères disponibles'} style={{
            margin: 0,
            padding: 20,
            height: User.CalculHeight.getHeightWanted(105),
            maxHeight: User.CalculHeight.getHeightWanted(105),
            overflowY: 'auto'
          }}>
            {this.state.dataonglet.map(function (infoTiers) {
              if (infoTiers.onglet_id === '' || infoTiers.onglet_id === null || infoTiers.onglet_id === undefined || infoTiers.onglet_id === 'null') {
                return <Grid key={Utils.getRandomNumber()} item style={{ margin: 0, padding: 0, width: '100%' }}>
                  <Draggable type="info_tiers_id" data={infoTiers.id}>
                      <EurestoDiv title={infoTiers.libelle}
                                  titleProps={{
                                    style: { width: '100%',cursor: 'grab' }
                                  }}/>
                  </Draggable>
                </Grid>
              }
            })}
          </EurestoDiv>
        </Grid>
        <Grid item xs={8} style={{ margin: 0, padding: 0 }}>
          <Grid container spacing={0} direction="row" justify="flex-start" alignItems="flex-start"
                style={{
                  margin: 0,
                  padding: 10,
                  height: User.CalculHeight.getHeightWanted(50),
                  maxHeight: User.CalculHeight.getHeightWanted(50),
                  overflowY: 'auto'
                }}>
            {this.state.onglet.map((onglet, index) => {
              return (
                <Grid key={Utils.getRandomNumber()} item style={{ margin: 0, padding: 0, width: '100%' }}>
                  <EurestoDiv key={Utils.getRandomNumber()} title={onglet.libelle} style={{ padding: 0 }}>
                    <Droppable
                      style={{ minHeight: 150, width: '100%', padding: 10 }}
                      types={['info_tiers_id']} // <= allowed drop types
                      onDrop={props => this.onDrop(props, onglet.id, (this.state.dataonglet.filter(infoTiers => infoTiers.onglet_id === onglet.id).length + 1))}
                      className="dropZone" id={'dropzone' + onglet.id}>
                      <Grid container spacing={0} direction="row" justify="flex-start" alignItems="flex-start"
                            style={{
                              margin: 0,
                              padding: 0,
                            }}>
                        {this.state.dataonglet.map((infoTiers) => {
                          if (infoTiers.onglet_id === onglet.id) {
                            return <Grid key={infoTiers + '-' + onglet.id} item xs={12} md={6}
                                         style={{ margin: 0, padding: 10 }}>
                              <EurestoDiv
                                titleProps={{
                                  style: { width: '100%' }
                                }}
                                title={
                                  <Grid container justify={'center'} alignContent={'space-around'}
                                        alignItems={'center'} style={{ width: '100%' }}>
                                    <Grid item>
                                      <Fab color={'default'}
                                           size="small"
                                           onClick={(e) => {
                                             e.stopPropagation()
                                             this.handleRequestDelete(infoTiers.id, onglet.id)
                                           }}
                                           className={'EurestoError--text EurestoText'}>
                                        <i className={'ei-commun_fermer EurestoError--text EurestoText'}/></Fab>
                                    </Grid>
                                    <Grid item xs style={{ textAlign: 'center' }}>
                                      {infoTiers.libelle}
                                    </Grid>
                                    <Grid item>
                                      <Select
                                        selectedTextClassName={'EurestoPrimaryr--text'}
                                        onChange={(val) => {
                                          this.onDrop({ info_tiers_id: infoTiers.id }, infoTiers.onglet_id, val)
                                        }}
                                        autoComplete={false}
                                        style={{ width: '54px', float: 'left', paddingBottom: 0 }}
                                        options={[...Array((this.state.dataonglet.filter(infoTiers => infoTiers.onglet_id === onglet.id).length)).keys()].map(o => ({
                                          label: o + 1,
                                          value: o + 1
                                        }))}
                                        value={infoTiers.ordre !== undefined ? infoTiers.ordre : 1}/>
                                    </Grid>
                                  </Grid>
                                }/>
                            </Grid>
                          }
                        })}
                      </Grid>
                    </Droppable>
                  </EurestoDiv></Grid>
              )
            })}
          </Grid>
        </Grid>
      </Grid>
    )
  }

  handleRequestDelete = (info_tiers_id, onglet_id) => {
    let jsonGet = {
      requete: 'onglet',
      action: 'unset'
    }
    jsonGet.id = onglet_id
    jsonGet.information_tiers_id = info_tiers_id
    ApiRequest(project.api + 'crm', jsonGet)
  }

  onDrop = (props, onglet_id, ordre) => {
    let jsonGet = {
      requete: 'onglet',
      action: 'set'
    }
    jsonGet.id = onglet_id
    jsonGet.information_tiers_id = props.info_tiers_id
    jsonGet.ordre = ordre
    ApiRequest(project.api + 'crm', jsonGet).then(
    )

  }

}



// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/CRM/GestionCritere/index.js